import clsx from 'clsx'
import { forwardRef } from 'react'

// Definizione del tipo per il componente Link
export type LinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'className'> & {
  className?: string
}

// Componente Link
export const Link = forwardRef<HTMLAnchorElement, LinkProps>(function Link({ className, ...props }, ref) {
  return (
    <a
      ref={ref}
      className={clsx(
        className,
        'transition-colors hover:text-zinc-950 dark:hover:text-white',
        props['aria-current'] === 'page'
          ? 'text-zinc-950 dark:text-white'
          : 'text-zinc-500 dark:text-zinc-400'
      )}
      {...props}
    />
  )
})